module.exports = __webpack_public_path__ + "img/5af9a2a368539836bbfef9a39b55fe6d.png";